import React, { useState } from 'react';

import {
  NozomiReconciliationExtra,
  NozomiReconciliationLayout,
} from '@totem/components/administration/reconciliation/nozomi/NozomiReconciliationLayout';
import {
  VantageAssetCountsExtra,
  VantageAssetCountsLayout,
} from '@totem/components/administration/reconciliation/nozomi/vantage/VantageAssetCountsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

type TabKey = 'reconciliation' | 'vantage';

// The card's header actions belong to the active tab, so the tabs live on the card itself.
const NozomiReconciliationTabs = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('reconciliation');

  return (
    <IBCard
      isCovered
      title="Nozomi Reconciliation"
      tabList={[
        { key: 'reconciliation', label: 'Reconciliation' },
        { key: 'vantage', label: 'Vantage Asset Counts' },
      ]}
      activeTabKey={activeTab}
      onTabChange={(key) => setActiveTab(key as TabKey)}
      extra={
        activeTab === 'reconciliation' ? (
          <NozomiReconciliationExtra />
        ) : (
          <VantageAssetCountsExtra />
        )
      }
    >
      {activeTab === 'reconciliation' ? (
        <NozomiReconciliationLayout />
      ) : (
        <VantageAssetCountsLayout />
      )}
    </IBCard>
  );
};

export default NozomiReconciliationTabs;
